import { render, staticRenderFns } from "./tabMain.vue?vue&type=template&id=604df4e3&scoped=true"
import script from "./tabMain.vue?vue&type=script&lang=js"
export * from "./tabMain.vue?vue&type=script&lang=js"
import style0 from "./tabMain.vue?vue&type=style&index=0&id=604df4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604df4e3",
  null
  
)

export default component.exports